import React from "react";

const VideoItem = ({ video, onVideoSelect }) => {
  const thumbnail = video?.snippet?.thumbnails?.medium?.url;
  const title = video?.snippet?.title;
  const channel = video?.snippet?.channelTitle;

  if (!thumbnail || !title) return null; // guard clause

  return (
    <div
      onClick={() => onVideoSelect(video)}
      className="cursor-pointer flex gap-2 mb-4 video-item"
    >
      <img src={thumbnail} alt={title} className="w-40 h-24 object-cover" />
      <div>
        <h4 className="font-semibold text-sm">{title}</h4>
        <p className="text-xs text-gray-600">{channel}</p>
      </div>
    </div>
  );
};

export default VideoItem;
